import listPage from './view/businessGuidelinesList.html';

export default {
  base: {
    state: 'declaration.corporateIncomeTax.businessGuidelines',
    config: {
      url: '/businessGuidelines',
      abstract: true,
      template: '<div ui-view></div>',
      default: 'declaration.corporateIncomeTax.businessGuidelines.list',
      title: '财务报表_企业会计准则',
    },
  },
  list: {
    state: 'declaration.corporateIncomeTax.businessGuidelines.list',
    config: {
      url: '/list',
      template: listPage,
      controller: 'businessGuidelinesListCtrl',
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/declaration/corporateIncomeTax/businessGuidelines/routers.js